export default "__VITE_ASSET__DvHDAEi1__"